"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5103],{

/***/ 95790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pl": function() { return /* reexport */ OtherPaymentMethods; },
  "KR": function() { return /* reexport */ isPaymentMethodDataOneClick; }
});

// UNUSED EXPORTS: AssistantVendorPaymentMethods, LocalVendorPaymentMethods

;// CONCATENATED MODULE: ./src/interfaces/paymentMethod.interface.ts
/*
 * File: paymentMethod.interface.ts
 * Project: meki
 * File Created: Monday, 5th October 2020 4:53:04 pm
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Thursday, 20th October 2022 12:07:53 am
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ var OtherPaymentMethods;
(function(OtherPaymentMethods) {
    OtherPaymentMethods["FINTOC"] = "Fintoc";
    OtherPaymentMethods["BANCO_ESTADO"] = "BancoEstado";
})(OtherPaymentMethods || (OtherPaymentMethods = {}));
function isPaymentMethodDataOneClick(data) {
    return typeof data === "object" && data !== null && "tbkUser" in data;
}

;// CONCATENATED MODULE: ./src/interfaces/order.interface.ts
/*
 * File: order.interface.ts
 * Project: meki
 * File Created: Wednesday, 21st October 2020 8:51:58 am
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Monday, 19th June 2023 9:56:11 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ var LocalVendorPaymentMethods;
(function(LocalVendorPaymentMethods) {
    LocalVendorPaymentMethods["TRANSFER"] = "TRANSFER";
    LocalVendorPaymentMethods["CARD_CASH"] = "CARD_CASH";
    LocalVendorPaymentMethods["CARD"] = "CARD";
    LocalVendorPaymentMethods["CASH"] = "CASH";
})(LocalVendorPaymentMethods || (LocalVendorPaymentMethods = {}));
var AssistantVendorPaymentMethods;
(function(AssistantVendorPaymentMethods) {
    AssistantVendorPaymentMethods["TRANSFER"] = "TRANSFER";
    AssistantVendorPaymentMethods["CARD"] = "CARD";
})(AssistantVendorPaymentMethods || (AssistantVendorPaymentMethods = {}));

;// CONCATENATED MODULE: ./src/interfaces/index.ts
/*
 * File: index.ts
 * Project: meki
 * File Created: Monday, 21st September 2020 5:35:28 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 3rd February 2023 9:38:17 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 























/***/ }),

/***/ 45482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ OrderDeliveryOptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);
/*
 * File: detail.ts
 * Project: meki
 * File Created: Wednesday, 10th November 2021 4:58:00 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 1st December 2023 11:26:50 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query OrderDeliveryOptions($params: OrderDeliveryOptionsParams!) {\n    orderDeliveryOptions(params: $params) {\n      dates\n      currentOrderId\n      deliveryCost\n      orders {\n        deliveryDate\n        deliveryType\n        deliveryCost\n        deliveryCoupon\n        totalCost\n        orderDetails {\n          quantity\n          product {\n            id\n            name\n            imagesUrl\n            activePrinciple\n            concentration\n            unit\n            prescriptionType\n            quantity\n            discount {\n              price\n              type\n              stockRestriction\n              dateRestriction\n              listPrice\n            }\n            format\n            price\n            container\n            containerQuantity\n            concentration\n            laboratory\n            availability {\n              stock\n              statusWithoutStock\n              status\n            }\n            metadata {\n              refrigerated\n            }\n          }\n          price\n          type\n          listPrice\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var OrderDeliveryOptions = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 43013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ setCheckoutOrderData; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation SetCheckoutOrderData($params: SetCheckoutOrderDataParams!) {\n    setCheckoutOrderData(params: $params) {\n      metadata {\n        useMekiCredits\n        chargeDeliveryCost\n        localVendor {\n          paymentMethod\n          mixPayments\n        }\n        assistantVendor {\n          paymentMethod\n        }\n        userInfo {\n          rut\n          name\n          email\n        }\n        sendEmail\n        insuranceInfo {\n          claimId\n          insuranceId\n          reimbursedProducts {\n            sku\n            observation\n            unitReimbursement\n            unitCopay\n            unitDeductible\n            coverage\n          }\n          rut\n          totalReimbursement\n          totalDeductible\n          totalCopay\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var setCheckoutOrderData = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 81993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ getInsuranceQuote; }
/* harmony export */ });
/* unused harmony export QuoteStatus */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query getInsuranceQuote($params: GetInsuranceQuote!) {\n    getInsuranceQuote(params: $params) {\n      claimId\n      insuranceId\n      totalDeductible\n      totalReimbursement\n      totalCopay\n      metadata\n      reimbursedProducts {\n        sku\n        observation\n        unitReimbursement\n        unitDeductible\n        unitCopay\n        coverage\n        quantity\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getInsuranceQuote = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};
var TributaryDocument;
(function(TributaryDocument) {
    TributaryDocument["BILL"] = "BILL";
    TributaryDocument["DISPATCH_NOTE"] = "DISPATCH_NOTE";
})(TributaryDocument || (TributaryDocument = {}));
var QuoteStatus;
(function(QuoteStatus) {
    QuoteStatus["PENDING"] = "PENDING";
    QuoteStatus["CONFIRMED"] = "CONFIRMED";
    QuoteStatus["CANCELLED"] = "CANCELLED";
    QuoteStatus["CANCELLED_FAILED"] = "CANCELLED_FAILED";
    QuoteStatus["DISCARDED"] = "DISCARDED";
})(QuoteStatus || (QuoteStatus = {}));


/***/ }),

/***/ 55678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ CardIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_icons_VisaIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(683);
/* harmony import */ var _paymentMethod_components_PaymentsOptions_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96966);
/* harmony import */ var _components_icons_MasterCardIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27064);
/* harmony import */ var _components_icons_RedCompraIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1991);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);






function CardIcon(props) {
    var icon;
    switch(props.creditCardType){
        case "Visa":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_VisaIcon__WEBPACK_IMPORTED_MODULE_1__/* .VisaIcon */ .Q, {});
            break;
        case "MasterCard":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_MasterCardIcon__WEBPACK_IMPORTED_MODULE_3__/* .MasterCardIcon */ .s, {});
            break;
        case "RedCompra":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_RedCompraIcon__WEBPACK_IMPORTED_MODULE_4__/* .RedCompraIcon */ .b, {});
            break;
        case "Fintoc":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                src: "/assets/images/bankIcon.png",
                alt: "bankIcon",
                height: 30,
                width: 30
            });
            break;
        case "BancoEstado":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                src: "/assets/images/bancoEstadoLogo.png",
                alt: "bancoEstadoLogo",
                height: 30,
                width: 30
            });
            break;
        default:
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                src: "/assets/images/cardIcon.png",
                alt: "bankIcon",
                height: 30,
                width: 30
            });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_paymentMethod_components_PaymentsOptions_styles__WEBPACK_IMPORTED_MODULE_2__/* .CardIconContainer */ .gM, {
        children: icon
    });
}


/***/ }),

/***/ 70276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ ErrorModal; },
  "C": function() { return /* binding */ ErrorModalTypes; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 4 modules
var useAuth = __webpack_require__(21566);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/ErrorModal.styles.ts


var RootDiv = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return {
        width: "100vw",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        height: "100vh",
        position: "fixed",
        background: " rgba(0,0,0,0.3)",
        zIndex: 4001,
        top: 0,
        right: 0,
        left: 0,
        color: theme.palette.primary.dark,
        "@media (min-width: 900px)": {
            justifyContent: "center"
        }
    };
});
var ModalDiv = (0,styled/* default */.Z)("div")({
    width: "95%",
    maxWidth: "336px",
    height: "auto",
    backgroundColor: "#FFFFFF",
    borderRadius: "10px",
    border: "1px solid #EAEAEA",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 4002,
    padding: "40px 0",
    marginTop: "83px",
    "@media (min-width: 900px)": {
        marginTop: 0
    }
});
var ErrorImg = (0,styled/* default */.Z)("img")({
    width: "38.67px",
    maxWidth: "200px",
    height: "auto",
    marginBottom: "17px"
});
var ErrorTitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: "17px",
    lineHeight: "25.5px",
    textAlign: "center",
    letterSpacing: "0.15px",
    color: "#414046",
    margin: "0 70px 12px 70px"
});
var ErrorSubtitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "21px",
    textAlign: "center",
    letterSpacing: "0.15px",
    color: "#414046",
    margin: "0 50px 30px 50px",
    span: {
        color: "#0277BD",
        cursor: "pointer",
        textDecoration: "underline"
    }
});
var ErrorButton = (0,styled/* default */.Z)("div")({
    height: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#0A7ABE",
    borderRadius: "100px",
    padding: "9px 31px",
    cursor: "pointer"
});
var ErrorButtonTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#FFFFFF"
});
var LoaderContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    marginBottom: "15px"
});


// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./src/queries/userInsurance/queries/getInsuranceQuote.ts
var getInsuranceQuote = __webpack_require__(81993);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./src/queries/order/mutations/setCheckoutOrderData.tsx
var setCheckoutOrderData = __webpack_require__(43013);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentConfirm/components/ErrorModal.tsx




















var ErrorModalTypes;
(function(ErrorModalTypes) {
    ErrorModalTypes["REGISTRY"] = "registryError";
    ErrorModalTypes["FINTOC"] = "fintocError";
    ErrorModalTypes["NOT_ALLOWED_ITEMS"] = "notAllowedItemsError";
    ErrorModalTypes["INVALID_INSURANCE"] = "invalidInsuranceError";
    ErrorModalTypes["DEFAULT"] = "default";
    ErrorModalTypes["NONE"] = "none";
})(ErrorModalTypes || (ErrorModalTypes = {}));
function ErrorModal(props) {
    var ref, ref1, ref2;
    var handleHideError = props.handleHideError, uuid = props.uuid, errorType = props.errorType, refetchOrder = props.refetchOrder;
    var registryError = errorType === ErrorModalTypes.REGISTRY;
    var fintocError = errorType === ErrorModalTypes.FINTOC;
    var notAllowedItemsError = errorType === ErrorModalTypes.NOT_ALLOWED_ITEMS;
    var invalidInsuranceError = errorType === ErrorModalTypes.INVALID_INSURANCE;
    var ref3 = (0,useAuth/* useAuth */.a)(), user = ref3.appUser;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var track = (0,useSegment/* useSegment */.K)().track;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,useOrderState/* useOrderState */.h)(), currentOrder = ref4.order;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var ref5;
    var id = (ref5 = uuid === null || uuid === void 0 ? void 0 : uuid.slice(0, 6).toUpperCase()) !== null && ref5 !== void 0 ? ref5 : "";
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)((0,getInsuranceQuote/* getInsuranceQuote */.H)(), {
        fetchPolicy: "network-only"
    }), 2), getInsuranceQuoteLazy = ref6[0], loading = ref6[1].loading;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)((0,setCheckoutOrderData/* setCheckoutOrderData */.r)()), 1), setCheckoutData = ref7[0];
    var ref8, ref9, ref10;
    var currentOrderPaymentInformation = {
        useMekiCredits: currentOrder.metadata.useMekiCredits,
        chargeDeliveryCost: currentOrder.metadata.chargeDeliveryCost,
        localVendor: {
            paymentMethod: (ref8 = (ref = currentOrder.metadata.localVendor) === null || ref === void 0 ? void 0 : ref.paymentMethod) !== null && ref8 !== void 0 ? ref8 : null,
            mixPayments: (ref9 = (ref1 = currentOrder.metadata.localVendor) === null || ref1 === void 0 ? void 0 : ref1.mixPayments) !== null && ref9 !== void 0 ? ref9 : null
        },
        assistantVendor: {
            paymentMethod: (ref10 = (ref2 = currentOrder.metadata.assistantVendor) === null || ref2 === void 0 ? void 0 : ref2.paymentMethod) !== null && ref10 !== void 0 ? ref10 : null
        },
        sendEmail: currentOrder.metadata.sendEmail,
        userInfo: currentOrder.metadata.userInfo,
        installments: currentOrder.metadata.installments
    };
    var handleRefreshQuote = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, response, newQuoteInfo, cleanReimbursedProducts, ref3, ref4, ref5, ref6, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            getInsuranceQuoteLazy({
                                variables: {
                                    params: {
                                        rut: currentOrder.metadata.insuranceInfo.rut
                                    }
                                }
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        newQuoteInfo = (ref = response.data) === null || ref === void 0 ? void 0 : ref.getInsuranceQuote;
                        cleanReimbursedProducts = newQuoteInfo === null || newQuoteInfo === void 0 ? void 0 : (ref1 = newQuoteInfo.reimbursedProducts) === null || ref1 === void 0 ? void 0 : ref1.map(function(product) {
                            if (product.coverage) {
                                return {
                                    sku: +product.sku,
                                    observation: product.observation,
                                    unitReimbursement: product.unitReimbursement,
                                    unitDeductible: product.unitDeductible,
                                    unitCopay: product.unitCopay,
                                    coverage: product.coverage,
                                    quantity: product.quantity
                                };
                            }
                        });
                        return [
                            4,
                            setCheckoutData({
                                variables: {
                                    params: {
                                        orderId: currentOrder.id,
                                        replace: true,
                                        metadata: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentOrderPaymentInformation), {
                                            insuranceInfo: {
                                                claimId: +(newQuoteInfo === null || newQuoteInfo === void 0 ? void 0 : newQuoteInfo.claimId),
                                                rut: (ref3 = newQuoteInfo === null || newQuoteInfo === void 0 ? void 0 : (ref2 = newQuoteInfo.metadata) === null || ref2 === void 0 ? void 0 : ref2.rut) !== null && ref3 !== void 0 ? ref3 : "",
                                                insuranceId: (ref4 = newQuoteInfo === null || newQuoteInfo === void 0 ? void 0 : newQuoteInfo.insuranceId) !== null && ref4 !== void 0 ? ref4 : null,
                                                totalReimbursement: (ref5 = newQuoteInfo === null || newQuoteInfo === void 0 ? void 0 : newQuoteInfo.totalReimbursement) !== null && ref5 !== void 0 ? ref5 : 0,
                                                totalDeductible: (ref6 = newQuoteInfo === null || newQuoteInfo === void 0 ? void 0 : newQuoteInfo.totalDeductible) !== null && ref6 !== void 0 ? ref6 : 0,
                                                reimbursedProducts: cleanReimbursedProducts !== null && cleanReimbursedProducts !== void 0 ? cleanReimbursedProducts : []
                                            }
                                        })
                                    }
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        refetchOrder !== null && refetchOrder !== void 0 ? refetchOrder : refetchOrder();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        void router.push(isLocalVendor ? (0,utils/* getRoute */.Bv)("checkoutPaymentMethodLocal") : (0,utils/* getRoute */.Bv)("checkoutPaymentMethod"));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleRefreshQuote() {
            return _ref.apply(this, arguments);
        };
    }();
    var onActionClick = function() {
        if (registryError) {
            void track("add payment error contact", {
                userId: user === null || user === void 0 ? void 0 : user.id,
                error: "registry error",
                paymentMethodType: fintocError ? "FINTOC" : "ONE PAY"
            });
        } else {
            void track("payment error contact", {
                userId: user === null || user === void 0 ? void 0 : user.id,
                error: "other error",
                paymentMethodType: fintocError ? "FINTOC" : "ONE PAY"
            });
        }
        window.open("https://api.whatsapp.com/send?phone=".concat(environment/* PHONE_NUMBER.CLEAN */.UE.CLEAN, "&text=").concat(encodeURI("Hola! Tengo problemas en pagar mi compra. El n\xfamero de mi orden es ".concat(id, "."))), "_blank");
    };
    var onButtonClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (notAllowedItemsError) {
                            void router.push((0,utils/* getRoute */.Bv)("home", {
                                s: "open"
                            }));
                            return [
                                2
                            ];
                        }
                        if (!invalidInsuranceError) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleRefreshQuote()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        handleHideError();
                        return [
                            2
                        ];
                }
            });
        });
        return function onButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    var defaultSubtitle = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Intenta nuevamente, prueba con otro m\xe9todo de pago o",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                onClick: onActionClick,
                children: "cont\xe1ctanos para ayudarte"
            })
        ]
    });
    var _obj;
    var errorTexts = (_obj = {}, (0,_define_property/* default */.Z)(_obj, ErrorModalTypes.REGISTRY, {
        title: "Hubo un problema registrando tu tarjeta",
        subtitle: defaultSubtitle
    }), (0,_define_property/* default */.Z)(_obj, ErrorModalTypes.FINTOC, {
        title: "Hubo un problema y no se realiz\xf3 el pago",
        subtitle: defaultSubtitle
    }), (0,_define_property/* default */.Z)(_obj, ErrorModalTypes.NOT_ALLOWED_ITEMS, {
        title: isLocalVendor ? "Algunos productos ya no estan disponibles" : "Se actualiz\xf3 tu carro",
        subtitle: isLocalVendor ? "Se actualiz\xf3 la orden. Revisa el carrito y vuelve a intentar" : "Revisa tus productos e intenta nuevamente"
    }), (0,_define_property/* default */.Z)(_obj, ErrorModalTypes.INVALID_INSURANCE, {
        title: "Se actualiz\xf3 el aporte de tu seguro",
        subtitle: "Revisa la nueva cobertura e intenta nuevamente"
    }), (0,_define_property/* default */.Z)(_obj, ErrorModalTypes.DEFAULT, {
        title: "Hubo un problema y no se realiz\xf3 el pago",
        subtitle: defaultSubtitle
    }), _obj);
    (0,react.useEffect)(function registryError() {
        if (registryError) {
            void track("add payment error", {
                userId: user === null || user === void 0 ? void 0 : user.id,
                error: "registry error",
                paymentMethodType: fintocError ? "FINTOC" : "ONE PAY"
            });
        } else {
            void track("payment error", {
                userId: user === null || user === void 0 ? void 0 : user.id,
                error: "registry error",
                paymentMethodType: fintocError ? "FINTOC" : "ONE PAY"
            });
        }
    }, [
        fintocError,
        registryError,
        track,
        user === null || user === void 0 ? void 0 : user.id
    ]);
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootDiv, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalDiv, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoaderContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 30,
                            color: "info"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTitleTypography, {
                        children: "Actualizando seguro..."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorSubtitleTypography, {
                        children: "Por favor, espera un momento"
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootDiv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalDiv, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorImg, {
                    src: "/assets/images/warningIcon.png"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorTitleTypography, {
                    children: errorTexts[errorType].title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorSubtitleTypography, {
                    children: errorTexts[errorType].subtitle
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorButton, {
                    onClick: onButtonClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorButtonTypography, {
                        children: notAllowedItemsError ? "Ver productos" : "Volver a intentar"
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 96966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ey": function() { return /* binding */ SkeletonOptionDescriptionText; },
/* harmony export */   "GF": function() { return /* binding */ ArrowIconContainer; },
/* harmony export */   "I3": function() { return /* binding */ OptionTitleText; },
/* harmony export */   "Os": function() { return /* binding */ ErrorTypography; },
/* harmony export */   "PM": function() { return /* binding */ InstallmentsText; },
/* harmony export */   "Qc": function() { return /* binding */ PaymentOptionSubSection; },
/* harmony export */   "cu": function() { return /* binding */ SkeletonOptionTitleText; },
/* harmony export */   "ex": function() { return /* binding */ OptionDescriptionText; },
/* harmony export */   "gM": function() { return /* binding */ CardIconContainer; },
/* harmony export */   "o3": function() { return /* binding */ NewCardLoaderContainer; },
/* harmony export */   "ox": function() { return /* binding */ OptionLeftContainer; },
/* harmony export */   "q4": function() { return /* binding */ OptionDiv; },
/* harmony export */   "rk": function() { return /* binding */ TextDiv; }
/* harmony export */ });
/* unused harmony exports RadioInput, AddOptionText, RadioInputSkeleton */
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13264);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91655);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29630);


var PaymentOptionSubSection = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    gap: "8px"
});
var OptionDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "quoteLoading";
    }
})(function(param) {
    var quoteLoading = param.quoteLoading;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "16px 8px 16px 16px",
        cursor: quoteLoading ? "default" : "pointer !important",
        opacity: quoteLoading ? 0.5 : 1
    };
});
var OptionLeftContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px"
});
var RadioInput = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("input")({
    cursor: "pointer",
    WebkitAppearance: "none",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    outline: "none",
    border: "2px solid #0277BD",
    ":before": {
        content: '""',
        display: "block",
        width: "60%",
        height: "60%",
        margin: "20% auto",
        borderRadius: "50%"
    },
    ":checked:before": {
        backgroundColor: "#0277BD"
    }
});
var RadioInputSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    width: "20px",
    height: "30px"
});
var TextDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column"
});
var OptionTitleText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#414046"
});
var InstallmentsText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: "300",
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#919191",
    "> span": {
        marginLeft: "5px",
        color: "#414046",
        fontWeight: "500"
    }
});
var SkeletonOptionTitleText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    width: "120px",
    height: "20px"
});
var OptionDescriptionText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "light";
    }
})(function(param) {
    var light = param.light;
    return {
        fontFamily: "Poppins",
        fontWeight: light ? "300" : "500",
        fontSize: "12px",
        lineHeight: "18px",
        letterSpacing: "0.16px",
        color: "#919191"
    };
});
var SkeletonOptionDescriptionText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    width: "80px",
    height: "20px"
});
var AddOptionText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.16px",
    color: "#0A7ABE",
    marginLeft: "27px"
});
var ErrorTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0.15px",
    color: "#D32F2F",
    marginTop: "6px",
    marginBottom: "6px"
});
var CardIconContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    backgroundColor: "#EAEAEA"
});
var ArrowIconContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "35px",
    height: "35px"
});
var NewCardLoaderContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
    marginRight: "5px",
    borderRadius: "10px",
    zIndex: 1
});



/***/ }),

/***/ 57500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLocalPaymentOption; },
/* harmony export */   "e": function() { return /* binding */ useLocalPaymentOptionsActions; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);

var useLocalPaymentOptionsStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)()(function(set) {
    return {
        paymentOption: null,
        mixPayments: {
            CASH: 0,
            CARD: 0
        },
        actions: {
            setPaymentOption: function(to) {
                return set({
                    paymentOption: to
                });
            },
            setMixPayments: function(param) {
                var CASH = param.CASH, CARD = param.CARD;
                set({
                    mixPayments: {
                        CASH: CASH,
                        CARD: CARD
                    }
                });
            },
            cleanValues: function() {
                set({
                    paymentOption: null,
                    mixPayments: {
                        CASH: 0,
                        CARD: 0
                    }
                });
            }
        }
    };
});
var useLocalPaymentOption = function() {
    return useLocalPaymentOptionsStore(function(state) {
        return {
            paymentOption: state.paymentOption,
            mixPayments: state.mixPayments
        };
    });
};
var useLocalPaymentOptionsActions = function() {
    return useLocalPaymentOptionsStore(function(state) {
        return state.actions;
    });
};


/***/ })

}]);